import * as yup from 'yup';

export const Tipo_estadoColumnList = (isAdmin) => {
   return [
      {
         id: 'tipo_estado_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'tipo_estado_nombre',
         dbname: 'nombre',
         label: 'nombre',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'tipo_estado_descripcion',
         dbname: 'descripcion',
         label: 'descripcion',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'tipo_estado_modulo_id',
         dbname: 'modulo_id',
         label: 'modulo_id',
         visible: true,
         form: true,
         filter: true,
         foreign: {
            table: 'modulo',
            label: 'modulo',
            dbname: 'modulodesc',
            type: 'large'
         }
      },
      {
         id: 'tipo_estado_fecha_creacion',
         dbname: 'fecha_creacion',
         label: 'fecha_creacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'tipo_estado_fecha_actualizacion',
         dbname: 'fecha_actualizacion',
         label: 'fecha_actualizacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'tipo_estado_final',
         dbname: 'final',
         label: 'final',
         visible: true,
         form: true,
         filter: false,
         type: 'boolean',
      },

   ];
};

export const Tipo_estadoValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombre: yup.string().required(t("not_emtpy_field")),
      descripcion: yup.string().nullable(),
      modulo_id: yup.number().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};

export const Tipo_estadoFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nombre: yup.string().nullable(),
      descripcion: yup.string().nullable(),
      modulo_id: yup.number().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};